import { render, staticRenderFns } from "./AccountContext.vue?vue&type=template&id=a68d5e08&scoped=true&"
import script from "./AccountContext.vue?vue&type=script&lang=js&"
export * from "./AccountContext.vue?vue&type=script&lang=js&"
import style0 from "./AccountContext.vue?vue&type=style&index=0&id=a68d5e08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68d5e08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a68d5e08')) {
      api.createRecord('a68d5e08', component.options)
    } else {
      api.reload('a68d5e08', component.options)
    }
    module.hot.accept("./AccountContext.vue?vue&type=template&id=a68d5e08&scoped=true&", function () {
      api.rerender('a68d5e08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/layout/sidebarComponents/AccountContext.vue"
export default component.exports